if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: this.querySelector('[data-product-gallery-dots]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.initializeDots();
        this.elements.viewer?.addEventListener('slideChanged', this.onSlideChanged.bind(this));

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });

          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        }
      }

      initializeDots() {
        if (!this.elements.dots || !this.elements.viewer) return;

        const mediaItems = Array.from(
          this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]')
        );
        this.elements.dots.replaceChildren();

        if (mediaItems.length <= 1) {
          this.elements.dots.hidden = true;
          return;
        }

        mediaItems.forEach((mediaItem, index) => {
          const dot = document.createElement('button');
          const mediaId = mediaItem.dataset.mediaId;

          dot.type = 'button';
          dot.className = 'product-gallery-dot';
          dot.dataset.target = mediaId;
          dot.setAttribute('aria-label', `${index + 1} / ${mediaItems.length}`);
          dot.addEventListener('click', () => this.setActiveMedia(mediaId, false));
          this.elements.dots.appendChild(dot);
        });

        this.elements.dots.hidden = false;
        const activeMedia = this.elements.viewer.querySelector('[data-media-id].is-active') || mediaItems[0];
        this.setActiveDot(activeMedia?.dataset.mediaId);
      }

      onSlideChanged(event) {
        const currentMedia = event.detail?.currentElement;
        if (!currentMedia) return;

        this.setActiveDot(currentMedia.dataset.mediaId);

        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentMedia.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveDot(mediaId) {
        if (!this.elements.dots || !mediaId) return;

        this.elements.dots.querySelectorAll('.product-gallery-dot').forEach((dot) => {
          const isActive = dot.dataset.target === mediaId;
          dot.classList.toggle('is-active', isActive);

          if (isActive) {
  dot.setAttribute('aria-current', 'true');

  /* Alleen de bolletjes horizontaal verschuiven.
     De volledige pagina mag niet naar de galerij scrollen. */
  const dotsContainer = this.elements.dots;

  if (dotsContainer.scrollWidth > dotsContainer.clientWidth) {
    const left =
      dot.offsetLeft -
      (dotsContainer.clientWidth - dot.offsetWidth) / 2;

    dotsContainer.scrollTo({
      left: Math.max(0, left),
      behavior: 'smooth',
    });
  }
} else {
  dot.removeAttribute('aria-current');
}
        });
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');
        this.setActiveDot(activeMedia.dataset.mediaId);

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) {
              activeThumbnail.parentElement.firstChild !== activeThumbnail &&
                activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

window.setTimeout(() => {
  /* De juiste variantafbeelding selecteren,
     zonder de volledige pagina omhoog te scrollen. */
  if (!this.mql.matches || this.elements.thumbnails) {
    activeMedia.parentElement.scrollTo({
      left: activeMedia.offsetLeft,
      behavior: 'smooth',
    });
  }
});
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image || !this.elements.liveRegion) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
